import { FunctionComponent } from 'react'

import styled from '@emotion/styled'

import { spacing, Stack, Text } from '@cash-design-system/react'

import { Capabilities, useHasCapability } from '../../utils/capabilities'

interface StyleProps {
  textAlignCenter?: boolean | null
  alignCenterHorizontally?: boolean
  maxWidth?: number
}

interface Props extends StyleProps {
  mainTitle: string
  secondaryTitle?: string
}

const StyledStack = styled(Stack)<StyleProps>`
  ${props => props.textAlignCenter && `text-align: center;`}
  ${props => props.alignCenterHorizontally && `margin: 0 auto;`}
  ${props => typeof props.maxWidth !== 'undefined' && `max-width: ${props.maxWidth}px;`}
`

export const PageTitle: FunctionComponent<Props> = ({
  mainTitle,
  secondaryTitle = '',
  textAlignCenter = null,
  alignCenterHorizontally = false,
  maxWidth,
}) => {
  const hasCap = useHasCapability()
  const center = textAlignCenter === null ? hasCap(Capabilities.CenteredFacePile) : textAlignCenter

  return (
    <StyledStack
      space={spacing.m}
      textAlignCenter={center}
      alignCenterHorizontally={alignCenterHorizontally}
      maxWidth={maxWidth}
    >
      <Text typography="tabTitle" color="textStandard" as="h3" data-testid="page-title">
        {mainTitle}
      </Text>
      {secondaryTitle.length > 0 && (
        <Text typography="body" color="textStandard" data-testid="page-secondary-title">
          {secondaryTitle}
        </Text>
      )}
    </StyledStack>
  )
}
